/*
 * Author: zoesvision.com
 * Purpose: Enable Z Newsletter submission only after consent is checked.
 */

class ZNewsletter extends HTMLElement {
  connectedCallback() {
    if (this.isConnectedOnce) return;

    this.consent = this.querySelector('[data-z-newsletter-consent]');
    this.submitButton = this.querySelector('[data-z-newsletter-submit]');
    this.form = this.querySelector('form');
    this.email = this.querySelector('input[type="email"]');
    if (!this.consent || !this.submitButton) return;

    this.isConnectedOnce = true;
    this.handleConsentChange = this.syncSubmitState.bind(this);
    this.consent.addEventListener('change', this.handleConsentChange);
    this.handleSubmit = this.routeLead.bind(this);
    this.form?.addEventListener('submit', this.handleSubmit);
    this.syncSubmitState();
  }

  disconnectedCallback() {
    this.consent?.removeEventListener('change', this.handleConsentChange);
    this.form?.removeEventListener('submit', this.handleSubmit);
    this.isConnectedOnce = false;
  }

  syncSubmitState() {
    this.submitButton.disabled = !this.consent.checked;
  }

  async routeLead(event) {
    if (this.dataset.nimoLeadRouted === 'true') return;

    const companyId = this.dataset.nimoKlaviyoCompanyId;
    const listId = this.dataset.nimoKlaviyoListId;
    const source = this.dataset.nimoLeadSource || 'Nimo OS Updates';
    const email = this.email?.value.trim();

    if (!companyId || !listId || !email || !this.consent.checked || !window.NimoLeadRouting) return;

    event.preventDefault();
    this.submitButton.disabled = true;

    try {
      await Promise.race([
        window.NimoLeadRouting.subscribeToKlaviyoList({
          companyId,
          listId,
          email,
          source,
          properties: {
            'Lead Source': source,
            'Lead Program': 'AI NAS',
          },
        }),
        new Promise((resolve) => window.setTimeout(resolve, 3000)),
      ]);
    } catch (error) {
      console.warn('Nimo lead routing could not reach Klaviyo.', error);
    } finally {
      this.dataset.nimoLeadRouted = 'true';
      this.form.submit();
    }
  }
}

if (!customElements.get('z-newsletter')) {
  customElements.define('z-newsletter', ZNewsletter);
}
